export function checkWindow() {
  return typeof window !== 'undefined';
}
